// extracted by mini-css-extract-plugin
export default {"cardList":"cardList_cardList__Um8ZA"};